import React, { useEffect, useRef } from "react";
import { FlaskConical, ArrowUpRight } from "lucide-react";
import { useAppConfig } from "@/lib/config";

export default function DemoBanner() {
  const cfg = useAppConfig();
  const ref = useRef(null);
  const on = !!cfg?.demo_mode;
  useEffect(() => {
    if (!on || !ref.current) return;
    const root = document.documentElement;
    const apply = () => {
      const h = `${ref.current?.offsetHeight || 0}px`;
      root.style.setProperty("--demo-banner-h", h);
      document.body.style.paddingTop = h;
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(ref.current);
    return () => { ro.disconnect(); root.style.removeProperty("--demo-banner-h"); document.body.style.paddingTop = ""; };
  }, [on]);
  if (!on) return null;
  return (
    <div ref={ref} className="fixed top-0 inset-x-0 z-[60] bg-amber-400 text-neutral-900 text-xs" data-testid="demo-banner" role="status">
      <div className="px-4 lg:px-8 py-2 flex items-center gap-x-4 gap-y-1 flex-wrap justify-center sm:justify-between">
        <p className="flex items-center gap-1.5 font-semibold">
          <FlaskConical size={13} /> Demo — sample data only.
          <span className="font-normal hidden md:inline">Listings, developers and investors here aren&apos;t real.</span>
        </p>
        {cfg.demo_accounts?.length > 0 && (
          <p className="flex items-center gap-2 flex-wrap justify-center" data-testid="demo-banner-accounts">
            <span className="font-semibold">Try it:</span>
            {cfg.demo_accounts.map((a) => (
              <span key={a.role} className="bg-white/60 rounded-full px-2 py-0.5 font-mono text-[11px]" data-testid={`demo-account-${a.role}`}>
                <span className="font-sans font-semibold capitalize">{a.role}</span> {a.email} / {a.password}
              </span>
            ))}
          </p>
        )}
        {cfg.live_url && (
          <a href={cfg.live_url} data-testid="demo-banner-live-link" className="inline-flex items-center gap-0.5 font-semibold underline underline-offset-2 hover:no-underline">
            Go to the live platform <ArrowUpRight size={12} />
          </a>
        )}
      </div>
    </div>
  );
}
